import { Link } from 'expo-router';
import { StyleSheet } from 'react-native';

import { useMenuClickEvents } from '@fhs/menu/src/analytics';
import { IconChevronDown, IconLocationFill, Pressable, Text, tokens } from '@fhs/ui';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export function MenuLocationButton() {
  const { store } = useStoreContext();
  const { isDelivery } = useServiceModeContext();
  const { logServiceModeBarClick } = useMenuClickEvents();
  const serviceMode = isDelivery ? 'Delivery' : 'Pickup';
  const label = store.name ? `${store.name} • ${serviceMode}` : 'Choose a location';

  return (
    <Link href={isDelivery ? routes.address : routes.storeLocator} asChild>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={`${label}. Change order location`}
        borderRadius={16}
        style={styles.locationButton}
        onPress={() =>
          logServiceModeBarClick({
            serviceMode,
            storeText: store.name || '',
          })
        }
      >
        <IconLocationFill size={14} color={tokens.colors.$houseRed} />
        <Text.Ui size="sm" weight="semibold" numberOfLines={1} style={styles.locationText}>
          {label}
        </Text.Ui>
        <IconChevronDown size={14} color={tokens.colors.$black} />
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  locationButton: {
    maxWidth: 220,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    backgroundColor: tokens.colors.$white,
  },
  locationText: {
    flexShrink: 1,
  },
});
